import { action } from 'satcheljs';
export default action('runRuleNow', function (inboxRule, sourceFolderId) { return ({
    inboxRule: inboxRule,
    sourceFolderId: sourceFolderId,
}); });
//# sourceMappingURL=runRuleNow.js.map